export const environment = () => {
	let name: string | undefined = undefined;
	let version: string | undefined = undefined;
	try {
		// eslint-disable-next-line @typescript-eslint/no-var-requires
		const versionGen = require('./version.gen');
		name = process.env.REACT_APP_VERSION ?? versionGen.name;
		version = process.env.REACT_APP_NAME ?? versionGen.version;
		return {
			NAME: name,
			VERSION: version,
			ENV: process.env.REACT_APP_ENV,
		};
	} catch (e) {
		// File does not exist or failed to load; fall back to undefined
		console.warn(
			'version.gen.ts not found or failed to load, using undefined for name and version'
		);
	}
};
